<script lang="ts">
  import { Wrapper } from './components';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;

  $: ({ background } = settings);
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  <div
    class="section-thou-curve wf-section"
    id={properties?.anchor}
    style="padding:0 15px;margin:0;"
  >
    <div
      class="div-spell-harbor"
      style="justify-content: {properties.textAlignment};"
    >
      <div class="div-raise-stairs">
        <p class="p-fairly-property">{properties?.subHeading}</p>
        {#if properties.heading}
          <h2
            class="h2-dirt-lonely"
            style="font-family: var(--vlt-lp-heading-font); color: var(--vlt-lp-text); text-align:{properties.alignment}"
          >
            {@html properties.heading}
          </h2>
        {/if}
      </div>

      <div class="div-purple-have">
        <div
          class="div-above-command"
          style="color: var(--vlt-lp-text); text-align: {properties.textAlignment}"
        >
          {@html properties.content}
        </div>
      </div>
      {#if properties?.items?.length}
        <ul>
          {#each properties.items as item}
            <li>
              <div class="bullet">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style="height:20px;line-height:20px;width:20px;vertical-align:middle;"
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M15.842 4.13062L8.99998 10.9479L6.21606 8.16395"
                    stroke={background}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.5937 7.27385C17.548 11.4699 14.9199 15.6451 10.7239 16.5994C6.52778 17.5536 2.35261 14.9256 1.39833 10.7295C0.44408 6.53344 3.07211 2.35827 7.26819 1.40399C9.40781 0.917413 11.6534 1.35556 13.4532 2.61076"
                    stroke={background}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span class="benefit-content">{@html item}</span>
            </li>
          {/each}
        </ul>
      {/if}
    </div>
  </div>
</Wrapper>

<style>
  .section-thou-curve {
    margin: 0 auto !important;
  }

  .div-spell-harbor {
    max-width: 80rem;
    margin-right: auto;
    margin-left: auto;
  }

  .div-raise-stairs {
    max-width: 42rem;
    margin-right: auto;
    margin-left: auto;
    padding: 0;
    text-align: center;
  }

  .p-fairly-property {
    margin: 0;
    padding: 0;
    color: var(--vlt-lp-accent);
    text-decoration: none;
    font-weight: 600;
  }

  .h2-dirt-lonely {
    margin-top: 2rem;
    margin-bottom: 0;
    font-size: 3rem;
    line-height: 1;
  }

  .div-purple-have {
    max-width: 48rem;
    margin-right: auto;
    margin-left: auto;
    padding: 0;
    font-weight: 400;
    text-decoration: none;
  }

  .div-above-command {
    margin: 0;
    padding: 1.5rem;
    text-align: center;
    font-family: var(--vlt-lp-paragraph-font, 'DM Sans');
  }

  ul {
    display: -ms-grid;
    display: grid;
    max-width: 48rem;
    margin-right: auto;
    margin-left: auto;
    padding: 0;
    grid-column-gap: 1.5rem;
    grid-row-gap: 1.5rem;
    -ms-grid-columns: minmax(0px, 1fr) minmax(0px, 1fr);
    grid-template-columns: minmax(0px, 1fr) minmax(0px, 1fr);
    -ms-grid-rows: auto;
    grid-template-rows: auto;
    font-weight: 400;
    margin-top: 50px;
    text-decoration: none;
    text-align: left;
  }

  ul li {
    border: 1px solid #e5e7eb;
    border-radius: 1rem;
    background-color: #fff;
    font-weight: 400;
    display: flex;
    text-decoration: none;
    list-style: none;
    padding: 1.25rem 1rem;
    color: #0e0f11;
  }

  ul li .bullet {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    content: '';
    min-width: 1.5rem;
    min-height: 1.5rem;
    margin-right: 0.75rem;
    vertical-align: middle;
    margin-bottom: auto;
  }

  @media screen and (min-width: 1280px) {
    .h2-dirt-lonely {
      margin-top: 2rem;
      font-size: 3rem;
      line-height: 1;
    }

    .div-purple-have {
      grid-column-gap: 1.5rem;
      grid-row-gap: 1.5rem;
      -ms-grid-columns: minmax(0px, 1fr) minmax(0px, 1fr);
      grid-template-columns: minmax(0px, 1fr) minmax(0px, 1fr);
    }

    .div-above-command {
      padding: 1.5rem;
    }
  }

  @media screen and (min-width: 1440px) {
    .h2-dirt-lonely {
      margin-top: 2rem;
      font-size: 3rem;
      line-height: 1;
    }

    .div-purple-have {
      grid-column-gap: 1.5rem;
      grid-row-gap: 1.5rem;
      -ms-grid-columns: minmax(0px, 1fr) minmax(0px, 1fr);
      grid-template-columns: minmax(0px, 1fr) minmax(0px, 1fr);
    }

    .div-above-command {
      padding: 1.5rem 1.5rem 0;
    }
  }

  @media screen and (max-width: 991px) {
    .h2-dirt-lonely {
      font-size: 2.25rem;
      line-height: 2.5rem;
    }

    .div-purple-have {
      grid-column-gap: 1.5rem;
      grid-row-gap: 1.5rem;
      -ms-grid-columns: minmax(0px, 1fr) minmax(0px, 1fr);
      grid-template-columns: minmax(0px, 1fr) minmax(0px, 1fr);
    }

    .div-above-command {
      padding: 1.5rem 0 0;
    }
  }

  @media screen and (max-width: 767px) {
    .section-thou-curve {
      padding: 0px 15px !important;
      margin: 0px auto !important;
    }

    .h2-dirt-lonely {
      font-size: 2.25rem;
      line-height: 2.5rem;
    }

    .div-purple-have {
      grid-column-gap: 1.5rem;
      grid-row-gap: 1.5rem;
    }

    .div-above-command {
      padding: 1.5rem 0 0;
    }
  }

  @media screen and (max-width: 640px) {
    .h2-dirt-lonely {
      margin-top: 1.5rem;
      font-size: 1.875rem;
      line-height: 2.25rem;
    }

    ul {
      grid-column-gap: 1.25rem;
      grid-row-gap: 1.25rem;
      -ms-grid-columns: minmax(0px, 1fr);
      grid-template-columns: minmax(0px, 1fr);
    }

    .div-above-command {
      padding: 1.25rem 0 0;
    }
  }

  .benefit-content {
    font-family: var(--vlt-lp-paragraph-font, 'DM Sans');
  }
</style>
